import { enableAiConfigModeTabs, enableNewAiConfigListView } from '@gonfalon/dogfood-flags/dogfood-flags';

export function shouldShowAiConfigModeTabs() {
  return enableAiConfigModeTabs() && !enableNewAiConfigListView();
}
